/**
 * Action creator for patching an account.
 *
 * The body is a JSON-Patch (RFC 6902) array — produced upstream by
 * `fast-json-patch`'s `compare(accountCopy, formattedValues)` plus
 * the manual `otherAddresses` / `instantSurveys` replace ops from
 * the legacy AccountEdit flow. We accept the array as-is so callers
 * keep full control over the diff shape; we don't re-diff here.
 *
 * Endpoint: PATCH /accounts/:uuid
 */
export const patchAccountAction = ({ uuid, patches }) => ({
  method: 'PATCH',
  endpoint: `/accounts/${uuid}`,
  body: patches,
});
